import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [
    {
      path: "*",
      redirect: "/"
    },
    {
      path: "/",
      name: "PageView",
      component: resolve => require(["@/view/PageView"], resolve),
      children: [
        {
          path: "/",
          redirect: "/home"
        },
        {
          path: "/home",
          name: "home",
          component: resolve => require(["@/view/HomePage"], resolve),
          meta: {
            // title: ""
          }
        },
        {
          path: "/software",
          name: "software",
          component: resolve => require(["@/view/Software"], resolve),
          meta: {
            title: "业务介绍"
          },
          children: []
        },
        {
          path: "/newsinformation",
          name: "newsinformation",
          component: resolve => require(["@/view/NewsInformation"], resolve),
          meta: {
            title: "公司动态"
          }
        },
        {
          path: "/newsdetail",
          name: "newsdetail",
          component: resolve => require(["@/view/NewsDetail"], resolve),
          meta: {
            title: "新闻详情"
          }
        },
        {
          path: "/companyintroduction",
          name: "companyintroduction",
          component: resolve =>
            require(["@/view/CompanyIntroduction"], resolve),
          meta: {
            title: "合作伙伴"
          }
        },
        {
          path: "/jobchance",
          name: "jobchance",
          component: resolve => require(["@/view/JobChance"], resolve),
          meta: {
            title: "招聘中心"
          }
        },
        {
          path: "/wxjobchance",
          name: "wxjobchance",
          component: resolve => require(["@/view/wxJob/JobChance"], resolve),
          meta: {
            title: "招贤纳士"
          }
        },
        {
          path: "/zxjobchance",
          name: "zxjobchance",
          component: resolve => require(["@/view/zxJob/JobChance"], resolve),
          meta: {
            title: "招贤纳士-莲花紫星"
          }
        },
        {
          path: "/contactus",
          name: "contactus",
          component: resolve => require(["@/view/ContactUs"], resolve),
          meta: {
            title: "关于我们"
          }
        },
        {
          path: "/jobDetails",
          name: "jobDetails",
          component: resolve => require(["@/view/JobDetails.vue"], resolve),
          meta: {
            title: "岗位详情"
          }
        },
        {
          path: "/wxjobDetails",
          name: "wxjobDetails",
          component: resolve =>
            require(["@/view/wxJob/JobDetails.vue"], resolve),
          meta: {
            title: "岗位详情"
          }
        },
        {
          path: "/zxjobDetails",
          name: "zxjobDetails",
          component: resolve =>
            require(["@/view/zxJob/JobDetails.vue"], resolve),
          meta: {
            title: "岗位详情"
          }
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js